// import auth from '@/utils/auth';
import store from '@/store';
import i18n from '@/i18n';
import downloadjs from 'downloadjs';
import api from '../../../api/documents';
import * as types from './types';

export default {
  getFolders(context, searchRequest) {
    if (!searchRequest.path || searchRequest.globalSearch !== undefined) {
      return context.commit(types.LOAD_FOLDERS_SUCCESS, []);
    }
    return api.getFolders(context, searchRequest)
      .then((data) => {
        if (data.length) {
          context.commit(types.LOAD_FOLDERS_SUCCESS, data);
        } else {
          context.commit(types.LOAD_FOLDERS_SUCCESS, []);
        }
      })
      .catch(() => {
        store.dispatch('application/finishLoading');
        context.commit(types.LOAD_FOLDERS_FAILED);
      });
  },

  getDocuments(context, searchRequest) {
    store.dispatch('application/startLoading');
    return api.getDocuments(context, searchRequest)
      .then((data) => {
        let newTotalPage = Math.ceil(data.count / searchRequest.limit);
        if (newTotalPage === 0) {
          newTotalPage = 1;
        }
        const computedDocuments = [];
        data.documents.forEach((document) => {
          const computedDoc = document;
          computedDoc.filteredMetaDatas = [];
          document.metaDatas.forEach((metaData) => {
            const item = JSON.parse(JSON.stringify(metaData));
            if (item.name !== 'periodStartDate' && item.name !== 'periodEndDate') {
              return;
            }

            computedDoc.filteredMetaDatas.push(item);
          });
          computedDocuments.push(computedDoc);
        });
        context.commit(types.LOAD_SUCCESS,
          { documents: computedDocuments,
            totalPages: newTotalPage,
            totalElmts: data.count,
          });
        store.dispatch('application/finishLoading');
        return data;
      })
      .catch(() => {
        console.log('catch ?');
        context.commit(types.LOAD_FAILED);
        store.dispatch('application/finishLoading');
      });
  },

  getDocument(context, id) {
    store.dispatch('application/startLoading');
    return api.getDocument(id)
      .then((data) => {
        store.dispatch('application/finishLoading');
        return data;
      })
      .catch(() => store.dispatch('application/finishLoading'));
  },

  getDocumentsSenders(context) {
    store.dispatch('application/startLoading');
    return api.getDocumentsSenders(context)
      .then((data) => {
        store.dispatch('application/finishLoading');
        context.commit(types.LOAD_DOCUMENTS_SENDERS_SUCCESS, data.senders);
      })
    .catch(() => {
      store.dispatch('application/finishLoading');
      context.commit(types.LOAD_DOCUMENTS_SENDERS_FAILED);
    });
  },

  getDetails(context, document) {
    const details = { location: '' };
    document.metaDatas.map((metaData) => {
      if (metaData.name === 'orgName') {
        details.location = `${details.location}/${metaData.value}`;
      }
      if (metaData.name === 'empName') {
        details.location = `${details.location}/${metaData.value}`;
      }
      if (metaData.name === 'docType') {
        details.location = `${details.location}/${metaData.value}`;
      }
      if (metaData.name === 'year') {
        details.location = `${details.location}/${metaData.value}`;
      }
      return details;
    });
    context.commit(types.LOAD_ONE, details);
    return details;
  },

  getDocTypes() {
    store.dispatch('application/startLoading');
    return api.getDocTypes()
      .then((data) => {
        store.dispatch('application/finishLoading');
        return data;
      })
      .catch(() => store.dispatch('application/finishLoading'));
  },

  getDocType(context, code) {
    store.dispatch('application/startLoading');
    return api.getDocType(code)
      .then((data) => {
        store.dispatch('application/finishLoading');
        return data;
      })
      .catch((error) => {
        store.dispatch('application/finishLoading');
        console.log(error);
      });
  },

  getStats(context) {
    store.dispatch('application/startLoading');
    return api.getStats()
      .then((data) => {
        store.dispatch('application/finishLoading');
        context.commit(types.LOAD_STATS_SUCCESS, data.data);
      })
      .catch(() => {
        store.dispatch('application/finishLoading');
        context.commit(types.LOAD_STATS_FAILED);
      });
  },

  getPdf(context, params) {
    store.dispatch('application/startLoading');
    return api.getPdf(params.description, params.id)
      .then((data) => {
        store.dispatch('application/finishLoading');
        return data.data;
      })
      .catch(() => store.dispatch('application/finishLoading'));
  },

  setDocRead(context, documentId) {
    store.dispatch('application/startLoading');
    return api.setDocRead(documentId)
      .then(data => data)
      .catch(error => Promise.reject(error))
      .finally(() => store.dispatch('application/finishLoading'));
  },

  download(context, [documentId, filename]) {
    store.dispatch('application/startLoading');
    return api.getDocumentContent(context, documentId)
      .then((response) => {
        downloadjs(response, `${filename}.pdf`, 'application/pdf');
        store.dispatch('application/finishLoading');
      })
      .catch(() => store.dispatch('application/finishLoading'));
  },

  downloadZip(context, [documentIds, filename]) {
    store.dispatch('application/startLoading');
    api.getArchive(context, documentIds)
      .then((response) => {
        console.log(response);
        downloadjs(response, filename);
        store.dispatch('application/finishLoading');
      })
      .catch(() => store.dispatch('application/finishLoading'));
  },

  downloadDropConfirmation(context, params) {
    store.dispatch('application/startLoading');
    return api.getDocumentAttestation(context, params.id)
      .then((response) => {
        downloadjs(response, `attestation_${params.filename}.pdf`, 'application/pdf');
        store.dispatch('application/finishLoading');
      })
      .catch(() => store.dispatch('application/finishLoading'));
  },

  sendChorusMetaValidation(context, params) {
    store.dispatch('application/startLoading');
    return api.sendChorusMetaValidation(params.docId, params.metaDatas)
      .then(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: 'Le document a été validé avec succès',
        });
      })
      .catch(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: 'Le document n\'a pas été validé, veuillez vérifier les informations saisies',
        });
      });
  },
  requestNewDocDirectDownloadLink(context, token) {
    store.dispatch('application/startLoading');
    return api.requestNewDocDirectDownloadLink(token).catch((error) => {
      console.log(error);
      store.dispatch('application/openSnackbar', {
        message: i18n.t('document.newDownloadLink.api.error.requestNewLink'),
      });
      return Promise.reject(error);
    }).finally(() => {
      store.dispatch('application/finishLoading');
    });
  },


/*  docUpload(context, params) {
    store.dispatch('application/startLoading');
    return api.docUpload(params.json, params.file)
      .then((response) => console.log(response))
      .catch(error => console.log(error));
  },*/
};



// WEBPACK FOOTER //
// ./src/store/modules/documents/actions.js